import { ResponsivePie } from '@nivo/pie'
import React, { useState, useEffect, useCallback } from 'react'
import { fetchWithJson } from "../../../lib/api";
import { error } from "../../../lib/userAlerts";
import endpoint from "../../../config/endpoint.json";
import { Radio } from '@nextui-org/react';

const DAYS_30 = 1
const DAYS_365 = 2
const DAYS_ALL = 3

const StopRatings = ({ clientId }) => {
  const [data, setData] = useState([]);
  const [chartType, setChartType] = useState(DAYS_30);

  const fetchData = useCallback(async (clientId) => {
    try {
      setData([]);
      const res = await fetchWithJson(endpoint.statsStopRatings, {
        company_id: clientId,
        allTime: chartType === DAYS_ALL,
        thisYear: chartType === DAYS_365
      });

      if (res.status !== 200) {
        error('Unable to fetch shipment ratings');
        return;
      }

      const responseData = await res.json();
      let chartData = [];

      if (responseData?.ratings?.totalRecs > 0) {
        if (responseData.ratings.under2 > 0) {
          chartData.push({
            id: '1 to 2 Stars',
            label: 'Poor',
            value: responseData.ratings.under2,
            percent: Math.round(100 * responseData.ratings.under2 / responseData.ratings.totalRecs)
          });
        }

        if (responseData.ratings.under3 > 0) {
          chartData.push({
            id: '2 to 3 Stars',
            label: 'Average',
            value: responseData.ratings.under3,
            percent: Math.round(100 * responseData.ratings.under3 / responseData.ratings.totalRecs)
          });
        }

        if (responseData.ratings.under4 > 0) {
          chartData.push({
            id: '3 to 4 Stars',
            label: 'Above Avg',
            value: responseData.ratings.under4,
            percent: Math.round(100 * responseData.ratings.under4 / responseData.ratings.totalRecs)
          });
        }

        if (responseData.ratings.under5 > 0) {
          chartData.push({
            id: '4 to 5 Stars',
            label: 'Excellent',
            value: responseData.ratings.under5,
            percent: Math.round(100 * responseData.ratings.under5 / responseData.ratings.totalRecs)
          });
        }
      }

      setData(chartData);
    } catch (err) {
      console.error(err);
      error('Unable to fetch shipment ratings');
    }
  }, [chartType]);

  useEffect(() => {
    if (clientId) {
      fetchData(clientId);
    }
  }, [clientId, fetchData]);

  const handleChartTypeChange = useCallback((newType) => {
    setChartType(newType);
  }, []);

  const plotGraph = () => (
    <ResponsivePie
      data={data}
      margin={{ top: 40, right: 80, bottom: 150, left: 80 }}
      innerRadius={0.8}
      padAngle={1}
      cornerRadius={2}
      activeOuterRadiusOffset={8}
      colors={{ scheme: 'pastel1' }}
      borderWidth={1}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 0.2]]
      }}
      arcLinkLabel={d => `${d.data.label} (${d.data.percent}%)`}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: 'color',
        modifiers: [['darker', 2]]
      }}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 56,
          itemsSpacing: 0,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: '#999',
          itemDirection: 'left-to-right',
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000'
              }
            }
          ]
        }
      ]}
    />
  );

  return (
    <div className='ba b--dotted bw1 mt2' style={{height: "60vh", width: "100%"}}>
      <Radio.Group 
        row 
        css={{mt: '0.75rem', padding: 10}}
        size='sm'
        value={chartType}
        onChange={handleChartTypeChange}
      >
        <Radio value={DAYS_30}>
          30 Days
          <Radio.Desc>Ratings for last 30 days</Radio.Desc>
        </Radio>
        <Radio value={DAYS_365}>
          365 Days
          <Radio.Desc>Ratings for last 365 days</Radio.Desc>                  
        </Radio>
        <Radio value={DAYS_ALL}>
          All Time
          <Radio.Desc>All stop ratings</Radio.Desc>                  
        </Radio>
      </Radio.Group>

      {data.length > 0 ? plotGraph() : (
        <p className="h-100 f4 fw2 tc" style={{position: 'relative', top: '50%'}}>
          No driver reviews available
        </p>
      )}
    </div>
  );
};

export default StopRatings;